import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14">
          <p className="text-xs font-label tracking-widest uppercase text-primary-600 mb-3">
            / Browse Collections
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight max-w-2xl">
            Shop by Category
          </h2>
          <p className="text-base text-foreground-600 mt-4 max-w-xl">
            Explore our comprehensive Hipobuy Spreadsheet categories. Each category links directly to verified product collections on our main platform.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-100">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} - Hipobuy Spreadsheet`}
                  title={`${cat.name} - Hipobuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <div className="mt-2 flex items-center gap-1 text-xs text-primary-500 font-medium">
                  <span>Explore</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}